import React from "react";
import DevicesRow from "./DevicesRow";

const DevicesView = ({ litTerms }) => (
  <div className="literary-devices devices">
    {litTerms.map((litTerm, index) => (
      <DevicesRow index={index} key={litTerm.id} litTerm={litTerm} />
    ))}
  </div>
);

export default DevicesView;
